export const useFilterStore = () => {
    /**
     * Initialize the filters stores.
     * Contains:
     *  - game.providers
     */
    const init = () => {
        window.Alpine.store("filters", {
            games: {
                providers: window.Alpine.reactive({
                    _data: [],
                    has(id) {
                        return this._data.includes(id);
                    },
                    add(id) {
                        if (!this.has(id)) {
                            this._data.push(id);
                        }
                    },
                    remove(id) {
                        const index = this._data.findIndex((p) => p == id);
                        if (index >= 0) {
                            this._data.splice(index, 1);
                        }
                    },
                    toggle(id) {
                        if (this.has(id)) {
                            this.remove(id);
                        } else {
                            this.add(id);
                        }
                    },
                    get list() {
                        return this._data;
                    },
                    get count() {
                        return this._data.length;
                    },
                    clear() {
                        this._data = [];
                    },
                }),
            },
        });
    };

    return { init };
};
